import { LabelFilter } from "../components/translation/statistics/TranslationStats";
import { Label } from "../model/Label";
import axiosInstance from "../utils/ApiUtils/axiosInstance";

export interface FetchTranslationExportsParams {
  translationId: number;
  filter: LabelFilter;
}

export type TranslationMode = "edit" | "review";

export const fetchTranslationLabels = async (
  { translationId, filter }: FetchTranslationExportsParams,
  mode: TranslationMode
): Promise<Label[]> => {
    const response =  await axiosInstance.get<ApiResponse<Label[]>>(
    `/api/translation/phase/${translationId}/${mode}-labels?filter=${encodeURIComponent(filter)}`
  );

  return response.data.data || [];

};
